import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Link } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import {
  AGREEMENT_TITLE_KEY_BY_TYPE,
  REQUIRED_SIGN_UP_AGREEMENTS,
} from '../../../redux/api/agreements/agreementPolicy';
import { AgreementType } from '../../../redux/api/agreements/interfaces';
import { useStyles } from './AgreementsLinks.styles';
import AgreementsModal, { AgreementsModalMode } from './AgreementsModal';

interface IAgreementsLinksProps {
  className?: string;
}

const AgreementsLinks = ({ className }: IAgreementsLinksProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { classes, cx } = useStyles(theme);
  const [termsAgreementType, privacyAgreementType] =
    REQUIRED_SIGN_UP_AGREEMENTS;
  const [openedAgreementType, setOpenedAgreementType] =
    useState<AgreementType | null>(null);

  const modalOpen = openedAgreementType !== null;
  const currentAgreementType = useMemo(
    () => openedAgreementType ?? AgreementType.TERMS_OF_USE,
    [openedAgreementType],
  );

  return (
    <>
      <Box component="span" className={cx(classes.root, className)}>
        {t('agreements.acceptPrefix')}{' '}
        <Link
          href="#terms-of-use"
          className={classes.linkButton}
          onClick={(event) => {
            event.preventDefault();
            setOpenedAgreementType(termsAgreementType);
          }}>
          {t(AGREEMENT_TITLE_KEY_BY_TYPE[termsAgreementType])}
        </Link>{' '}
        {t('agreements.and')}{' '}
        <Link
          href="#privacy-policy"
          className={classes.linkButton}
          onClick={(event) => {
            event.preventDefault();
            setOpenedAgreementType(privacyAgreementType);
          }}>
          {t(AGREEMENT_TITLE_KEY_BY_TYPE[privacyAgreementType])}
        </Link>
      </Box>
      <AgreementsModal
        open={modalOpen}
        mode={AgreementsModalMode.VIEW}
        agreementType={currentAgreementType}
        onClose={() => setOpenedAgreementType(null)}
      />
    </>
  );
};

export default AgreementsLinks;
